export enum OfferStatusEnum {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE',
    COMPLETE = 'COMPLETE',
    CANCELLED = 'CANCELLED',
    EXPIRED = 'EXPIRED'
}
